import { render } from "./index.vue?vue&type=template&id=3633a35e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=3633a35e&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=3633a35e&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3633a35e"]])

export default __exports__